import Vue from 'vue'

import pin from '@/api/pin'
import * as types from '../mutation-types'

const state = {
  currentUserPin: null,
  userPins: []
}

const getters = {
  currentUserPin: (state) => {
    return state.currentUserPin
  },
  pinByUsername: (state) => (username) => {
    return state.userPins && state.userPins[username] ? state.userPins[username] : null
  }
}

const actions = {
  // gets a pin for a specific user
  getUserPin ({ commit, state }, { userName, isCurrentUser }) {
    return new Promise((resolve, reject) => {
      if (state.userPins[userName]) {
        return resolve(state.userPins[userName])
      }
      pin.getUserPin(userName).then((response) => {
        const pin = response.data.result.pin
        commit(types.ADD_USER_PIN, { userName, pin, isCurrentUser })
        resolve(pin)
      }, (error) => {
        reject(error)
      })
    })
  },
  // gets the pins a user has collected
  getUserPins ({ commit }, { username, limit, offset }) {
    return new Promise((resolve, reject) => {
      pin.getPins(username, limit, offset, false).then((response) => {
        const pins = response.data.result.pins
        const total = response.data.result.total
        const hasMore = response.data.result.hasMore
        resolve({ pins, total, hasMore })
      }, (error) => {
        reject(error)
      })
    })
  },
  updatePin ({ commit }, { pinURL, userName }) {
    return new Promise((resolve, reject) => {
      pin.update(pinURL, userName).then((response) => {
        const pin = response.data.result.pin
        commit(types.ADD_USER_PIN, { userName, pin, isCurrentUser: true })
        resolve(pin)
      }, (error) => {
        reject(error)
      })
    })
  },
  sendPinSwapRequest ({ commit }, { sendingUser, receivingUser }) {
    return new Promise((resolve, reject) => {
      pin.sendSwapRequest(sendingUser, receivingUser).then((response) => {
        resolve(response.data.result.pin)
      }, (error) => {
        reject(error)
      })
    })
  },
  getUserHasSwapped ({ commit }, { viewingUser, viewedUser }) {
    return new Promise((resolve, reject) => {
      pin.getUserHasSwapped(viewingUser, viewedUser).then((response) => {
        resolve(response.data.result.pin)
      }, (error) => {
        reject(error)
      })
    })
  },
  getUserHasCollected ({ commit }, { viewingUser, viewedUser }) {
    return new Promise((resolve, reject) => {
      pin.getUserHasCollected(viewingUser, viewedUser).then((response) => {
        resolve(response.data.result.pin)
      }, (error) => {
        reject(error)
      })
    })
  },
  updatePinOrder ({ commit }, userPinIDs) {
    return new Promise((resolve, reject) => {
      pin.updatePinOrder(userPinIDs).then((response) => {
        resolve(response.data.result.userPins)
      }, (error) => {
        reject(error)
      })
    })
  },
  collectBoothPin ({ commit }, boothOwner) {
    return new Promise((resolve, reject) => {
      pin.collectPin(boothOwner).then((response) => {
        resolve(response.data.result.pin)
      }, (error) => {
        reject(error)
      })
    })
  }
}

const mutations = {
  [types.ADD_USER_PIN] (state, params) {
    if (params.isCurrentUser) {
      state.currentUserPin = params.pin
    }
    Vue.set(state.userPins, params.userName, params.pin)
  },
  [types.RESET_ON_LOGOUT] (state) {
    state.currentUserPin = {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
